import { render, staticRenderFns } from "./onboardingStep.vue?vue&type=template&id=4822da90&scoped=true&"
import script from "./onboardingStep.vue?vue&type=script&lang=js&"
export * from "./onboardingStep.vue?vue&type=script&lang=js&"
import style0 from "./onboardingStep.vue?vue&type=style&index=0&id=4822da90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4822da90",
  null
  
)

export default component.exports